module.exports = __webpack_public_path__ + "static/media/sportsBet.529c0966.png";